import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FeedbackComponent} from './feedback/feedback.component';
import {ListFeedbackComponent} from './list-feedback/list-feedback.component';
import {FormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {DataTablesModule} from 'angular-datatables';
import {FeedbackRoutingModule} from './feedback.routing.module';
import {TranslationModule} from '../i18n/translation.module';
import {SharedModule} from '../../shared/shared.module';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ViewFeedbackComponent} from './view-feedback/view-feedback.component';
import {ProceduresModule} from "../procedures/procedures.module";


@NgModule({
    declarations: [FeedbackComponent, ListFeedbackComponent, ViewFeedbackComponent],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        DataTablesModule,
        FeedbackRoutingModule,
        TranslationModule,
        SharedModule,
        NgbTooltipModule,
        ProceduresModule
    ],
    exports: [FeedbackComponent, ListFeedbackComponent, ViewFeedbackComponent]
})
export class FeedbackModule {
}
